import styled from 'styled-components';

export const CategoriesHorizontal = styled.div`
  background-color: ${props => props.theme.color.white};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
  overflow-x: scroll;
  padding: 0.625rem 0 1.25rem 0;
  padding-right: 0.9375rem;
`;

export const CategoryItem = styled.div`
  max-width: 64px;
  text-align: center;
  margin-left: 1.5625rem;

  & > a {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &:first-child {
    margin-left: 0;
  }
`;

export const WrapperImage = styled.div`
  height: 56px;
  width: 56px;
  min-width: 56px;
  border-radius: 100%;
  border: 0.0625rem solid ${(props) => props.caregoriesBorderColor};
  overflow: hidden;
  margin-bottom: 0.25rem;
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 0;
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
`;

export const Title = styled.div`
  font-size: 0.75rem;
  color: ${({theme}) => theme.color.black};
  font-weight: ${({theme}) => theme.fontWeight.fw400};
  line-height: 1;
`;


// * Products
export const Products = styled.div``;

// * Partners
export const Partners = styled.div``;